let chapter = [
    {
      "dyName": "聚焦问题",
      easy: 6,
      "chapterInfo": [
        {
          "isread": false,
          "chapterid": "65a2f3ce-dc5c-6dae-6d5f-25910f3135ac",
          "title": "",
          "courseName": "",
          "taskJson": [
            {
              "task": "头脑风暴",
              "taskDetail": "",
              "chapterData": [],
              "toolText": "",
              "toolChoose": [
                {
                  "tool": [],
                  "toolDetail": "",
                  "toolType": 0,
                  "askCount": 1,
                  "askTitle": "",
                  "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }]
                }
              ],
              "isShowTools": false,
              "askCount": 1,
              "isFold": 0,
              "askTitle": "",
              "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }],
              "checkJson": [{ "checkCount": [], "checkPerent": [] }],
              "homeworkList": [],
              "proVisible": false,
              "proVisible2": false
            },
            {
              "task": "确定问题",
              "taskDetail": "",
              "chapterData": [],
              "toolText": "",
              "toolChoose": [
                {
                  "tool": [],
                  "toolDetail": "",
                  "toolType": 0,
                  "askCount": 1,
                  "askTitle": "",
                  "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }]
                }
              ],
              "isShowTools": false,
              "askCount": 1,
              "isFold": 0,
              "askTitle": "",
              "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }],
              "checkJson": [{ "checkCount": [], "checkPerent": [] }],
              "homeworkList": [],
              "proVisible": false,
              "proVisible2": false
            },
            {
              "task": "情境任务",
              "taskDetail": "",
              "chapterData": [],
              "toolText": "",
              "toolChoose": [
                {
                  "tool": [],
                  "toolDetail": "",
                  "toolType": 0,
                  "askCount": 1,
                  "askTitle": "",
                  "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }]
                }
              ],
              "isShowTools": false,
              "askCount": 1,
              "isFold": 0,
              "askTitle": "",
              "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }],
              "checkJson": [{ "checkCount": [], "checkPerent": [] }],
              "homeworkList": [],
              "proVisible": false,
              "proVisible2": false
            },
            {
              "task": "设计方案",
              "taskDetail": "",
              "chapterData": [],
              "toolText": "",
              "toolChoose": [
                {
                  "tool": [],
                  "toolDetail": "",
                  "toolType": 0,
                  "askCount": 1,
                  "askTitle": "",
                  "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }]
                }
              ],
              "isShowTools": false,
              "askCount": 1,
              "isFold": 0,
              "askTitle": "",
              "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }],
              "checkJson": [{ "checkCount": [], "checkPerent": [] }],
              "homeworkList": [],
              "proVisible": false,
              "proVisible2": false
            }
          ],
          "itemCount": 1,
          "fileList1": [],
          "video": [],
          "testData": [],
          "pData": [],
          "templateArray": []
        }
      ]
    }, {
      "dyName": "解决问题",
      easy: 6,
      "chapterInfo": [
        {
          "isread": false,
          "chapterid": "65a2f3ce-dc5c-6dae-6d5f-25910f3135ac",
          "title": "",
          "courseName": "",
          "taskJson": [
            {
              "task": "综合感知",
              "taskDetail": "",
              "chapterData": [],
              "toolText": "",
              "toolChoose": [
                {
                  "tool": [],
                  "toolDetail": "",
                  "toolType": 0,
                  "askCount": 1,
                  "askTitle": "",
                  "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }]
                }
              ],
              "isShowTools": false,
              "askCount": 1,
              "isFold": 0,
              "askTitle": "",
              "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }],
              "checkJson": [{ "checkCount": [], "checkPerent": [] }],
              "homeworkList": [],
              "proVisible": false,
              "proVisible2": false
            },
            {
              "task": "具身体验",
              "taskDetail": "",
              "chapterData": [],
              "toolText": "",
              "toolChoose": [
                {
                  "tool": [],
                  "toolDetail": "",
                  "toolType": 0,
                  "askCount": 1,
                  "askTitle": "",
                  "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }]
                }
              ],
              "isShowTools": false,
              "askCount": 1,
              "isFold": 0,
              "askTitle": "",
              "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }],
              "checkJson": [{ "checkCount": [], "checkPerent": [] }],
              "homeworkList": [],
              "proVisible": false,
              "proVisible2": false
            },
            {
              "task": "探索实践",
              "taskDetail": "",
              "chapterData": [],
              "toolText": "",
              "toolChoose": [
                {
                  "tool": [],
                  "toolDetail": "",
                  "toolType": 0,
                  "askCount": 1,
                  "askTitle": "",
                  "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }]
                }
              ],
              "isShowTools": false,
              "askCount": 1,
              "isFold": 0,
              "askTitle": "",
              "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }],
              "checkJson": [{ "checkCount": [], "checkPerent": [] }],
              "homeworkList": [],
              "proVisible": false,
              "proVisible2": false
            },
            {
              "task": "建构知识",
              "taskDetail": "",
              "chapterData": [],
              "toolText": "",
              "toolChoose": [
                {
                  "tool": [],
                  "toolDetail": "",
                  "toolType": 0,
                  "askCount": 1,
                  "askTitle": "",
                  "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }]
                }
              ],
              "isShowTools": false,
              "askCount": 1,
              "isFold": 0,
              "askTitle": "",
              "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }],
              "checkJson": [{ "checkCount": [], "checkPerent": [] }],
              "homeworkList": [],
              "proVisible": false,
              "proVisible2": false
            }
          ],
          "itemCount": 1,
          "fileList1": [],
          "video": [],
          "testData": [],
          "pData": [],
          "templateArray": []
        }
      ]
    }, {
      "dyName": "运用智造",
      easy: 6,
      "chapterInfo": [
        {
          "isread": false,
          "chapterid": "65a2f3ce-dc5c-6dae-6d5f-25910f3135ac",
          "title": "",
          "courseName": "",
          "taskJson": [
            {
              "task": "联通经验",
              "taskDetail": "",
              "chapterData": [],
              "toolText": "",
              "toolChoose": [
                {
                  "tool": [],
                  "toolDetail": "",
                  "toolType": 0,
                  "askCount": 1,
                  "askTitle": "",
                  "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }]
                }
              ],
              "isShowTools": false,
              "askCount": 1,
              "isFold": 0,
              "askTitle": "",
              "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }],
              "checkJson": [{ "checkCount": [], "checkPerent": [] }],
              "homeworkList": [],
              "proVisible": false,
              "proVisible2": false
            },
            {
              "task": "转化运用",
              "taskDetail": "",
              "chapterData": [],
              "toolText": "",
              "toolChoose": [
                {
                  "tool": [],
                  "toolDetail": "",
                  "toolType": 0,
                  "askCount": 1,
                  "askTitle": "",
                  "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }]
                }
              ],
              "isShowTools": false,
              "askCount": 1,
              "isFold": 0,
              "askTitle": "",
              "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }],
              "checkJson": [{ "checkCount": [], "checkPerent": [] }],
              "homeworkList": [],
              "proVisible": false,
              "proVisible2": false
            },
            {
              "task": "智造成果",
              "taskDetail": "",
              "chapterData": [],
              "toolText": "",
              "toolChoose": [
                {
                  "tool": [],
                  "toolDetail": "",
                  "toolType": 0,
                  "askCount": 1,
                  "askTitle": "",
                  "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }]
                }
              ],
              "isShowTools": false,
              "askCount": 1,
              "isFold": 0,
              "askTitle": "",
              "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }],
              "checkJson": [{ "checkCount": [], "checkPerent": [] }],
              "homeworkList": [],
              "proVisible": false,
              "proVisible2": false
            },
            {
              "task": "展示表达",
              "taskDetail": "",
              "chapterData": [],
              "toolText": "",
              "toolChoose": [
                {
                  "tool": [],
                  "toolDetail": "",
                  "toolType": 0,
                  "askCount": 1,
                  "askTitle": "",
                  "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }]
                }
              ],
              "isShowTools": false,
              "askCount": 1,
              "isFold": 0,
              "askTitle": "",
              "askJson": [{ "askstitle": "", "askItem": 1, "checkList": [] }],
              "checkJson": [{ "checkCount": [], "checkPerent": [] }],
              "homeworkList": [],
              "proVisible": false,
              "proVisible2": false
            }
          ],
          "itemCount": 1,
          "fileList1": [],
          "video": [],
          "testData": [],
          "pData": [],
          "templateArray": []
        }
      ]
    },
  ]
  
  
  export default chapter


// WEBPACK FOOTER //
// ./src/components/pages/components/weilai.js